/*
 * @Author: Chao Yang
 * @Date: 2019-09-29 01:22:01
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-08 10:38:40
 */
import { HeaderMenuItem } from './header-menu-item';
export class HeaderUserItem {
  constructor() {
    this.menus = [];
    this.name = '';
  }
  public menus: HeaderMenuItem[];
  public name: string;
}
